import React, { useState, useEffect } from 'react';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddNotificationForm = ({ type, editData, onSuccess, onClose }) => {
  const [formData, setFormData] = useState({
    title: '',
    topic: '',
    shortDesc: '',
    longDesc: '',
  });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const token = sessionStorage.getItem("jwtToken");
  const [operationSuccess, setOperationSuccess] = useState(false);

  useEffect(() => {
    if (editData) {
      setFormData({
        title: editData.title || '',
        topic: editData.topic || '',
        shortDesc: editData.shortDesc || '',
        longDesc: editData.longDesc || '',
      });
    }
  }, [editData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let shortType = '';
    if (type === 'App') shortType = 'A';
    else if (type === 'WhatsApp') shortType = 'W';
    else if (type === 'Email') shortType = 'E';

    const finalPayload = {
      ...formData,
      type: shortType,
      sendWhatsappNoti: shortType === 'W',
      sendPopupNoti: shortType === 'A',
    };

    try {
      const url = editData
        ? `${BASE_URL}/notifications/updateNotification/${editData.id}`
        : `${BASE_URL}/createNotifications`;

      const method = editData ? 'PUT' : 'POST';
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
           Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(finalPayload),
      });

      const result = await response.json();

      const message =
        result.status?.message ||
        result.data ||
        (editData ? 'Notification updated successfully' : 'Notification added successfully');

      // Show success/error modal first
      setModalMessage(message);
      setOperationSuccess(response.ok);
      setShowModal(true);

    } catch (err) {
      setModalMessage(
        err.message ||
          (editData ? 'Error updating notification' : 'Error adding notification')
      );
      setOperationSuccess(false);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <form className="row g-3" onSubmit={handleSubmit} style={{ marginTop: '20px', marginBottom: '30px' }}>
        <div className="row align-items-center mb-3 fw-bold">
          <label htmlFor="title" className="col-sm-3 col-form-label">Title</label>
          <div className="col-sm-9">
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              className="form-control"
              required
            />
          </div>
        </div>

        <div className="row align-items-center mb-3 fw-bold">
          <label htmlFor="topic" className="col-sm-3 col-form-label">Topic</label>
          <div className="col-sm-9">
            <input
              type="text"
              id="topic"
              name="topic"
              value={formData.topic}
              onChange={handleInputChange}
              className="form-control"
              placeholder="please insert same as key"
              required
            />
          </div>
        </div>

        <div className="row align-items-center mb-3 fw-bold">
          <label htmlFor="shortDesc" className="col-sm-3 col-form-label">Short Description</label>
          <div className="col-sm-9">
            <input
              type="text"
              id="shortDesc"
              name="shortDesc"
              value={formData.shortDesc}
              onChange={handleInputChange}
              className="form-control"
              required
            />
          </div>
        </div>

        <div className="row align-items-center mb-3 fw-bold">
          <label htmlFor="longDesc" className="col-sm-3 col-form-label">Long Description</label>
          <div className="col-sm-9">
            <textarea
              id="longDesc"
              name="longDesc"
              value={formData.longDesc}
              onChange={handleInputChange}
              className="form-control"
              rows="5"
              required
            />
          </div>
        </div>

        <div className="text-center fw-bold">
          {editData ? (
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Updating...' : 'Update Notification'}
            </button>
          ) : (
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Adding...' : 'Add Notification'}
            </button>
          )}
        </div>
      </form>

      {/* Modal for Success/Error */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editData ? 'Update Status' : 'Add Status'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>{modalMessage}</p>
              </div>
              <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  setShowModal(false);               // close success/error modal
                  if (operationSuccess && onSuccess) onSuccess(); // refresh table only if successful
                  if (onClose) onClose();             // close Add/Edit form modal
                }}
              >
                OK
              </button>
            </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddNotificationForm;
